import { TaxStatus } from 'src/admin-entity/enum/product/tax-status.enum';
import { CalculationSummary } from 'src/admin-entity/interface/calculation/calculation-summary.interface';
import { Calculation } from 'src/admin-entity/interface/calculation/calculation.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';

export interface CalculationInitType {
    pagination: {
        page: number;
        take: number;
        beginDate: string;
        endDate: string;
        taxStatus: TaxStatus;
        distributor: {
            id: number;
            name: string;
        };
        searchType: string;
    };
    calculationPage: Page<Calculation>;
    calculationSummary: CalculationSummary;
}

export const initialState: CalculationInitType = {
    pagination: {
        page: 0,
        take: 25,
        beginDate: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString(),
        endDate: new Date().toISOString(),
        taxStatus: 'tax-all',
        distributor: {
            id: 0,
            name: '선택 안함',
        },
        searchType: 'deliveringDate',
    },
    calculationPage: {
        page: {
            count: 0,
        },
        list: [],
    },
    calculationSummary: {
        oipCount: 0,
        salesQuantity: 0,
        withdrawOipCount: 0,
        withdrawProductSupplyPrice: 0,
        withdrawShippingFee: 0,
        productSupplyPrice: 0,
        shippingFee: 0,
        settlementAmount: 0,
    },
};
